
import { useNavigate } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import { FaPlus} from "react-icons/fa6";
import { IoMdSearch } from "react-icons/io";
import { GoMegaphone } from "react-icons/go";
import { ROUTES } from "../../../routes/routes";
import { strings } from "../../../strings/strings";

const QuickActions = () => {
  const navigate = useNavigate();

  const handleAddCompany = () => {
    navigate(ROUTES.ADMIN_COMPANY, { state: { openAddModal: true } });
  };

  const handleSearchCompany = () => {
    navigate(ROUTES.ADMIN_COMPANY, { state: { focusSearch: true } });
  };

  const handleAddAnnouncement = () => {
    navigate(ROUTES.ADMIN_ANNOUNCEMENTS, { state: { openAddModal: true } });
  };

  const actions = [
    {
      id: 1,
      icon: FaPlus,
      label: "Add New Company",
      color: "primary",
      gradient: "from-primary to-primary-dark dark:from-primary-dark dark:to-primary/80",
      onClick: handleAddCompany,
    },

    {
      id: 2,
      icon: IoMdSearch,
      label: strings.SEARCH_COMPANY,
      color: "blue",
      gradient: "from-blue-500 to-blue-600 dark:from-blue-600 dark:to-blue-700",
      onClick: handleSearchCompany,
    },
    {
      id: 3,
      icon: GoMegaphone,
      label: "Add Announcement",
      color: "purple",
      gradient: "from-purple-500 to-purple-600 dark:from-purple-600 dark:to-purple-700",
      onClick: handleAddAnnouncement,
    },
  ];

  return (
    <div className="relative bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-200 dark:border-gray-700 p-6 h-fit max-h-96 backdrop-blur-sm">
      {/* Background Pattern/Texture */}
      <div className="absolute inset-0 bg-gradient-to-br from-gray-50/50 to-gray-100/30 dark:from-gray-700/30 dark:to-gray-800/50 rounded-xl"></div>
      
      {/* Content */}
      <div className="relative z-10 h-full flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between mb-4 flex-shrink-0">
          <h2 className="text-xl font-bold text-gray-900 dark:text-white">{strings.QUICK_ACTION_TITLE}</h2>
        </div>

        {/* Actions List with Vertical Scroll */}
        <div className="space-y-2 overflow-y-auto flex-1 pr-2 scrollbar-thin" style={{ maxHeight: '300px' }}>
          {actions.map((action) => {
            const Icon = action.icon;
            return (
              <button
                key={action.id}
                onClick={action.onClick}
                className={`group w-full flex items-center gap-3 p-2.5 bg-gradient-to-r ${action.gradient} text-white rounded-xl transition-all duration-200 shadow-md hover:shadow-lg transform hover:scale-[1.005] relative`}
              >
                {/* Button Background Effect */}
                <div className="absolute inset-0 bg-white/5 opacity-0 group-hover:opacity-100 transition-opacity duration-200 rounded-xl"></div>
                
                {/* Icon */}
                <div className="relative z-10 flex-shrink-0 w-6 h-6 bg-white/20 rounded-lg flex items-center justify-center backdrop-blur-sm shadow-lg">
                  <Icon className="w-3.5 h-3.5" />
                </div>

                {/* Label */}
                <span className="relative truncate z-10 font-semibold text-sm text-left flex-1">{action.label}</span>

                {/* Arrow */}
                <FaArrowRight className="relative z-10 w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default QuickActions;
